// extracted by mini-css-extract-plugin
export default {"options":"LinkTypeField_options__EZ9zA","label":"LinkTypeField_label__qnqdN","emailUrl":"LinkTypeField_emailUrl__bEo2c"};